import React, { useContext } from 'react';
import styles from './CustomizePageSection.module.less';
import MultiLangSection from '../MultiLangSection';
import { MULTI_LANG_CONTENT_TYPES } from '../Constants/values';
import CustomizePageContext from '../CustomizeContext/CustomizePageContext';
import cx from 'classnames';
import CustomizeSectionStepHeader from './CustomizeSectionStepHeader';
import CustomizeComponentFactory from '../CustomizeComponentFactory';

const CustomizeSection = ({ ecmContent, contentIndex }) => {
  const { title, content } = ecmContent;

  const { showStepNumbers } = useContext(CustomizePageContext);

  const anchorProps = {
    visible: true,
    value: title.toLowerCase().split(' ').join('-')
  };

  return (
    <div className={styles.section_wrapper}>
      <CustomizeSectionStepHeader
        showStepNumbers={showStepNumbers}
        contentIndex={contentIndex}
        title={title}
        anchor={anchorProps}
      />
      <div
        className={cx(styles.content_wrapper, {
          [styles.content_wrapper_no_padding]: !showStepNumbers
        })}
      >
        {content.map((item) => {
          if (item.key === 'multiLanguageContainer') {
            return (
              <MultiLangSection
                ecmContent={item}
                contentType={MULTI_LANG_CONTENT_TYPES.content}
                key={item.id}
              />
            );
          }
          return (
            <CustomizeComponentFactory
              ecmContent={item}
              className="customizePageElement"
              key={item.id}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CustomizeSection;
